/* eslint-disable */
const resortLocationsList = {
    'btc': {
        name: 'TURKS &amp; CAICOS',
        city: 'PROVIDENCIALES',
        country: 'TURKS &amp; CAICOS',
        link: '/resorts/turks-caicos/',
        images: [
            'btc-01.jpg',
            'btc-02.jpg',
            'btc-03.jpg',
            'btc-04.jpg',
            'btc-05.jpg'
        ]
    },
    'bbo': {
        name: 'Ocho Rios',
        city: 'Ocho Rios',
        country: 'Jamaica',
        link: '/resorts/ocho-rios/',
        images: [
            'bbo-01.jpg',
            'bbo-02.jpg',
            'bbo-03.jpg',
            'bbo-04.jpg',
            'bbo-05.jpg',
            'bbo-06.jpg',
            'bbo-07.jpg'
        ]
    },
    'bng': {
        name: 'Negril',
        city: 'Negril',
        country: 'Jamaica',
        link: '/resorts/negril/',
        images: [
            'bng-01.jpg',
            'bng-02.jpg',
            'bng-03.jpg',
            'bng-04.jpg',
            'bng-05.jpg',
            'bng-06.jpg'
        ]
    }
};

module.exports = resortLocationsList;
